"use client";

import React, { useEffect, useState, useRef, memo } from "react";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import PopUpCart from "@/app/(main)/cart/_components/PopUpCart";

// query setup strapi

import { Caption } from "../ui/typography";
import { Separator } from "../ui/separator";
import Menu from "./components/Menu";
import MobileMenu from "./components/MobileMenu";
import UserDropDown from "./components/UserDropDown";
import LangaugeDropDown from "./components/LangaugeDropDown";
import { cmsUrl } from "@/app/config";
import SearchBar from "./components/SearchBar";
import { useFetchData } from "@/app/hooks/query";
import NavbarSkeleton from "@/components/Loading/NavbarSkeleton";
import { getFlashSaleActiveData } from "@/app/redux/flash-sale-management/flash-sale-service";
import FlashSaleTimer from "./components/FlashSaleTimer";
import { useGetProductCategories } from "./api";

function Navbar({ promotion = false }) {
  const [fixed, setFixed] = useState(false);
  const [flashSaleStatusData, setFlashSaleStatusData] = useState({
    status: false,
    time: "",
    loading: false,
  });
  const navRef = useRef(null);
  const pathName = usePathname();
  const { categoryList, isLoading, error } = useGetProductCategories();

  const { data: flashSaleActiveData, refetch: refetchFlashSaleActiveData } = useFetchData(
    ["getFlashSaleActiveData"],
    () => getFlashSaleActiveData(),
    {
      enabled: false,
    }
  );

  useEffect(() => {
    if (pathName === "/") {
      refetchFlashSaleActiveData();
    } else {
      setFlashSaleStatusData({
        status: false,
        time: "",
        loading: false,
      });
    }
  }, [pathName]);

  useEffect(() => {
    setFlashSaleStatusData({
      status: false,
      time: "",
      loading: true,
    });
    if (flashSaleActiveData?.data && flashSaleActiveData?.data?.data && flashSaleActiveData?.data?.data?.isActive) {
      setFlashSaleStatusData({
        status: flashSaleActiveData?.data?.data?.isActive,
        time: flashSaleActiveData?.data?.data?.expire_time,
        loading: false,
      });
    } else {
      setFlashSaleStatusData({
        status: false,
        time: "",
        loading: false,
      });
    }
  }, [flashSaleActiveData]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 90) {
        setFixed(true);
      } else {
        setFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (isLoading) return <NavbarSkeleton />;

  return (
    <>
      <div ref={navRef} className="">
        <nav
          className={`w-full  fixed bg-system-white  ease-in-out opacity-100 z-50 top-0 animate__animated animate__fadeIn`}
          style={{ transition: "top 0.5s ease, opacity 0.5s ease" }}
        >
          <div className=" border-b border-midnightIndigo-200    top-0 ">
            <div className=" p-4 lg:px-11 lg:py-[22px] flex justify-between items-center w-full mx-auto max-w-[1440px] h-[56px] lg:h-[86px]">
              <div>
                <Link href="/">
                  <Image
                    src={`${cmsUrl}/api/media/file/logo_14b7a08d75.svg`}
                    height={34}
                    width={155}
                    alt="logo"
                    className="w-[111px] h-[24px]  sm:w-[118px] sm:h-[25px] md:w-[155px] md:h-[34px] lg:h-[42px]"
                  />
                </Link>
              </div>

              <div className={"hidden md:block md:ml-[20px] lg:ml-[60px]"}>
                <SearchBar />
              </div>

              <ul className="flex gap-3 md:gap-6 py-4 items-center  ">
                <li className="cursor-pointer">
                  <UserDropDown />
                </li>
                <li className="hidden lg:flex cursor-pointer">
                  <Separator
                    orientation="vertical"
                    className="w-[1px] h-[29px] rounded bg-midnightIndigo-350 opacity-20"
                  />
                </li>
                <li className="mr-[12px] text-midnightIndigo-400 cursor-pointer">
                  <PopUpCart />
                </li>
                <li className="hidden md:flex  text-midnightIndigo-400 md:w-[30px] lg:w-auto cursor-pointer">
                  <LangaugeDropDown />
                </li>
                <li className="flex  md:hidden cursor-pointer">
                  <SearchBar />
                </li>
                <li className="block lg:hidden cursor-pointer">
                  <MobileMenu categoryList={categoryList} />
                </li>
              </ul>
            </div>
          </div>

          <div className={fixed ? "shadow " : " lg:border-b-[1px] border-midnightIndigo-200"}>
            <div className="py-6 px-11 h-[68px] top-0 w-full mx-auto max-w-[1440px] hidden lg:flex">
              <Menu categoryList={categoryList} />
            </div>
          </div>

          {/* <AllCategoriesMenu /> */}
          {/* {pathName === "/" && promotion && isFlashQuoteVisible == true && (
            <Caption
              className={`bg-system-sky text-center lg:border-t border-midnightIndigo-200 text-midnightIndigo-400 p-[7px] truncate text-nowrap ${
                promotion ? "block" : "hidden"
              }   ${
                !fixed
                  ? "block animate__animated animate__fadeIn"
                  : "animate__animated animate__fadeOut hidden "
              }`}
            >
              {promoMessage}
            </Caption>
          )} */}
          {pathName === "/" &&
            flashSaleStatusData.status &&
            (flashSaleStatusData.loading ? (
              <Caption
                className={`bg-system-sky text-center lg:border-t border-midnightIndigo-200 text-midnightIndigo-400 p-[7px] truncate text-nowrap ${
                  promotion ? "block" : "hidden"
                }   ${
                  !fixed ? "block animate__animated animate__fadeIn" : "animate__animated animate__fadeOut hidden "
                }`}
              >
                Loading...
              </Caption>
            ) : (
              <FlashSaleTimer promotion={promotion} fixed={fixed} endTime={flashSaleStatusData.time} />
            ))}
        </nav>
      </div>
      <div className="h-[56px]  md:h-[60px] lg:h-[155px]" />
    </>
  );
}

export default memo(Navbar);
